import React from 'react';
import { object } from 'prop-types';

import { connect } from 'react-redux';

import { isString } from 'lodash';

import clsx from 'clsx';

import EditIssueTypeIcons from './EditIssueTypeIcons';

import moment from 'moment';

import * as ServiceManagementActions from '../../../actions/serviceManagementActions';

import classes from './Overview.module.css';
import { getTimeZoneAbbr } from '../../../helpers/timezones';

const HealthIcon = ({health}) => {
    if (!isString(health)) return <span className={clsx(classes.healthIcon, classes.empty)} />;

    switch (health.toLowerCase()) {
        case 'high':
            return (
                <span className={clsx(classes.healthIcon, classes.high)} />
            );
        case 'medium':
            return (
                <span className={clsx(classes.healthIcon, classes.medium)} />
            );
        case 'low':
            return (
                <span className={clsx(classes.healthIcon, classes.low)} />
            );
        default:
            return (
                <span className={clsx(classes.healthIcon, classes.empty)} />
            );
    }
};

const Overview = ({
    activeItem,
    ...props
}) => {
    const renderManagedBy = (locked, managedBy) => {
        if (!locked) return 'BOB';

        if (!managedBy) return 'Not Available';

        const lastName = managedBy.lastName.toLowerCase();

        if (lastName === 'integration' || lastName === 'signature') {
            return managedBy.firstName;
        }

        return `${managedBy.firstName} ${managedBy.lastName}`;
    };

    return (
        <div className={classes.Overview}>
            <div className={classes.summary}>
                <HealthIcon
                    health={activeItem.priority}
                />
                <span>
                    {activeItem.summary || 'Summary Here'}
                </span>
            </div>
            <div className={classes.dataColumns}>
                <div className={classes.column}>
                    <div className={classes.row}>
                        <div className={classes.overviewLabel}>
                            Issue Types
                        </div>
                        <div className={classes.rowData}>
                            <div className={classes.icons}>
                                <EditIssueTypeIcons
                                    issues={activeItem.issueTypes}
                                    showButton
                                    disabled={activeItem.locked}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={classes.row}>
                        <div className={classes.overviewLabel}>
                            Request Source
                        </div>
                        <div className={classes.rowData}>
                            {activeItem.source}
                        </div>
                    </div>
                </div>
                <div className={classes.column}>
                    <div className={classes.row}>
                        <div className={classes.overviewLabel}>
                            Created On
                        </div>
                        <div className={classes.rowData}>
                            {moment.utc(activeItem.insertTimestamp).local().format('YYYY-MM-DD h:mm:ss A') + ' ' + getTimeZoneAbbr(activeItem.insertTimestamp, moment.tz.guess())}
                        </div>
                    </div>
                    <div className={classes.row}>
                        <div className={classes.overviewLabel}>
                            Managed By
                        </div>
                        <div className={classes.rowData}>
                            {renderManagedBy(activeItem.locked, activeItem.lockedByUserDetails)}
                        </div>
                    </div>
                </div>
                <div className={classes.column}>
                    <div className={classes.row}>
                        <div className={classes.overviewLabel}>
                            Last Update
                        </div>
                        <div className={classes.rowData}>
                            {moment.utc(activeItem.lastModifiedTimestamp).local().format('YYYY-MM-DD h:mm:ss A') + ' ' + getTimeZoneAbbr(activeItem.lastModifiedTimestamp, moment.tz.guess())}
                        </div>
                    </div>
                </div>
            </div>
            <div className={classes.description}>
                <div className={classes.overviewLabel}>
                    Description
                </div>
                <div className={classes.descriptionContent}>
                    {activeItem.description || 'Add a brief description.'}
                </div>
            </div>
        </div>
    );
};

Overview.defaultProps = {
    activeItem: {}
};

Overview.propTypes = {
    activeItem: object
};

const mapStateToProps = state => {
    return {
        activeItem: state.svcManagement.activeItem
    };
};

const mapDispatchToProps = {
    ...ServiceManagementActions
};

export default connect(mapStateToProps, mapDispatchToProps)(Overview);
